
const warehouseClerk = [
  {
    path: '/warehouse-clerk',
    name: 'warehouse-clerk',
    component: () => import('@/views/wxapp/warehouse-clerk'),
    redirect: '/warehouse-clerk/list',
    meta: {
      title: '仓储管理'
    },
    children: [
      {
        path: 'list',
        name: 'warehouse-clerk-list',
        component: () => import('@/views/wxapp/warehouse-clerk/list'),
        meta: {
          title: '出库单'
        }
      },
      {
        path: 'logisticsOrder',
        name: 'logistics-order',
        component: () => import('@/views/wxapp/warehouse-clerk/logisticsOrder'),
        meta: {
          title: '物流单'
        }
      }
    ]
  },
  {
    path: '/listDetails',
    name: 'list-details',
    component: () => import('@/views/wxapp/warehouse-clerk/list/listDteails'),
    meta: {
      title: '出库单详情'
    }
  },
  {
    path: '/establishLogistics',
    name: 'establish-logistics',
    component: () => import('@/views/wxapp/warehouse-clerk/logisticsOrder/establishLogistics'),
    meta: {
      title: '仓库管理'
    }
  },
  {
    path: '/createLogisticsOrder',
    name: 'create-logistics-order',
    component: () => import('@/views/wxapp/warehouse-clerk/logisticsOrder/createLogisticsOrder'),
    meta: {
      title: '创建物流单'
    }
  },
  {
    path: '/updateLogistics',
    name: 'update-logistics',
    component: () => import('@/views/wxapp/warehouse-clerk/logisticsOrder/updateLogistics'),
    meta: {
      title: '更新物流信息'
    }
  },
  {
    path: '/arrivedLogistics',
    name: 'arrived-logistics',
    component: () => import('@/views/wxapp/warehouse-clerk/logisticsOrder/arrivedLogistics'),
    meta: {
      title: '更新物流信息'
    }
  },
  {
    path: '/addSpecialCar',
    name: 'add-special-car',
    component: () => import('@/views/wxapp/warehouse-clerk/logisticsOrder/addSpecialCar'),
    meta: {
      title: '添加专车'
    }
  },
  {
    path: '/logisticsOrderDetails',
    name: 'logistics-order-details',
    component: () => import('@/views/wxapp/warehouse-clerk/logisticsOrder/logisticsOrderDetails'),
    meta: {
      title: '物流单详情'
    }
  }
]
export default warehouseClerk
